import PropTypes from "prop-types";
import FilterByLocation from "../College/Search/FilterByLocation";

function LocationFilterModal({ filters, onClose }) {
  return (
    <div
      className="
        py-5
        flex
        px-10
        flex-1
        flex-col
        mobile:px-5
        tablet-sm:px-5
        overflow-hidden
      "
    >
      <FilterByLocation
        isModal={true}
        filters={filters?.selected || []}
        onSubmit={({ type, filters }) => onClose({ type, filters })}
      />
    </div>
  );
}

LocationFilterModal.propTypes = {
  onClose: PropTypes.func,
  filters: PropTypes.shape()
};

export default LocationFilterModal;
